// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".monetization-card__container[data-v-04c62c94]{background-color:#291840;border:1px solid #3e2f53;border-radius:16px}.monetization-card__content[data-v-04c62c94]{height:100%}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
